
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.676 15.973a10.052 10.052 0 001.175 5.151 5.446 5.446 0 006.306 2.408 4.284 4.284 0 003.09-3.6l.109-.61c1.737.251 4.537.658 6.274.906l-.11.44a11.256 11.256 0 01-2.7 5.39 9.439 9.439 0 01-5.366 2.688 14.61 14.61 0 01-8.277-.819 10.151 10.151 0 01-5.777-6.24 16.225 16.225 0 01.019-11.45 10.538 10.538 0 018.963-7.054 13.353 13.353 0 016.666.555 9.571 9.571 0 016.167 6.9c.094.352.114.417.114.417-1.932.351-4.319.8-6.238 1.215-.362-1.915-1.265-3.428-3.2-3.9a5.263 5.263 0 00-6.616 3.57 10.49 10.49 0 00-.385 1.439 12.31 12.31 0 00-.214 2.594z","fill":"#005f91"}})])
          )
        }
      }
    